import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import EmailVerifiedModal from "./modals/EmailVerifiedModal";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./VerifyEmail.css";
import ReCAPTCHA from "react-google-recaptcha";

export default function VerifyEmail() {
  const { token } = useParams();
  const [pendingAccountExists, setPendingAccountExists] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [err, setErr] = useState("");
  const [emailVerifiedModal, setEmailVerifiedModal] = useState(false);
  const { dispatch } = useAuthContext();
  const [capVal, setCapVal] = useState(null);


  const handleVerify = async () => {
    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/user/${token}`
      );
      if (response.status === 200) {
        dispatch({ type: "LOGIN", payload: response.data });
        setEmailVerifiedModal(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErr(error.response.data);
      } else {
        console.error(error);
        setErr("An unexpected error occurred.");
      }
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${ApiConnectionString}/api/PendingAccCheckExists/${token}`
        );
        if (response.status === 200) {
          setPendingAccountExists(response.data);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setErr(error.response.data);
        } else {
          console.error(error);
          setErr("An unexpected error occurred.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      getData();
    } else {
      setIsLoading(false);
    }
  }, [token]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else if (!emailVerifiedModal) {
    return (
      <div className="container">
        {pendingAccountExists ? (
          <div className="verify-form d-flex flex-column justify-content-center align-items-center text-center">
            {!err ? (
              <div>
                <h2>Membotic</h2>
                <p>Please check the box and click 'Verify Email' to proceed.</p>

                <div className="my-2">
                  <ReCAPTCHA
                    sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                    onChange={(val) => setCapVal(val)}
                  />
                </div>

                {!capVal ? (
                  <button
                    disabled={true}
                    className="btn btn-primary btn-lg my-2 verify-button"
                  >
                    Verify
                  </button>
                ) : (
                  <button
                    onClick={handleVerify}
                    className="btn btn-primary btn-lg my-2 verify-button"
                  >
                    Verify
                  </button>
                )}
              </div>
            ) : (
              <div>
                <p className="text-danger">{err}</p>
              </div>
            )}
          </div>
        ) : (
          <div>No pending account found.</div>
        )}
 
      </div>
    );
  }else{
    return (
        <div>
     <EmailVerifiedModal />
        </div>
    )
  }
}
